import React, { useState, useEffect, useRef, useCallback } from "react";
import SideBar from "../Sidebar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import "./style.css";
import Footer from "../Footer/Footer";
import {
  denialHeader,
  adjustCodeDenial,
  dueDateData, redeniedData, issueTypes
} from "./data";
import { RoCheckbox } from "layouts/Form/Checkbox";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Box,
  Autocomplete,
  ButtonGroup,
  Menu,
  MenuItem,
  IconButton,
  TablePagination,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import API from "Api";
import ClaimNoteHistory from "./noteHistory";
import { NotificationManager } from "react-notifications";
import { denialSearchItems } from "../Footer/data";
import { DenialTable } from "./DataTable";
import { denailFilterDropdown } from "../Footer/data";
import { RoAlert } from "layouts/RoAlert";
import { socketInstance, getClientKey } from "../../socket/connection";
import ruleoutLogo from '../../assets/icons/logo2.svg';
import Loader from 'react-loader-spinner';
import exportIcon from '../../assets/icons/export.svg';
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import NoRecordFound from "./noRecordFound";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { dateConvertToUSTime, formatPhoneNumber, formatToMMDDYYYY } from "components/helper/helper";

var userRole = sessionStorage.getItem("userDetail");
let user = JSON.parse(userRole)
var socket = socketInstance();
var clientKey = getClientKey();

try {
  userRole = JSON.parse(userRole)?.role_Name;
} catch (error) {
  alert("User details not found in session");
}

const DenialWorksheet = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [actionTakenDenial, setActionTakenDenial] = useState([]);
  const [whatsNeededDenial, setWhatsNeededDenial] = useState([])

  var actionTakenD = null;
  let userArr = ["Sytem Administrator", "System Administrator", "Rule Creator"]
  if (!userArr.includes(userRole)) {
    actionTakenD = actionTakenDenial.filter((item) => {
      return item.value !== "Remove";
    });
  } else {
    actionTakenD = actionTakenDenial;
  }

  // for converting the normal date to US date
  // const dateConvertToUSTime = (date) => {
  //   let newDate = ''
  //   if (date) {
  //     if (date.includes('-')) {
  //       let dateArr = date.split('-')
  //       newDate = `${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`
  //       return newDate;
  //     } else {
  //       let dateArr = date.split('/')
  //       let month = dateArr[0] < 10 ? `0${dateArr[0]}` : dateArr[0]
  //       let day = dateArr[1] < 10 ? `0${dateArr[1]}` : dateArr[1]
  //       return `${month}/${day}/${dateArr[2]}`
  //     }
  //   }
  // }

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [denialList, setDenialList] = useState([]);
  const [denialListAllRows, setDenialListAllRows] = useState([]);
  const [denialListCopy, setDenialListCopy] = useState([]);
  const [allDenialList, setAllDenialList] = useState([]);
  const [assignTo, setAssignTo] = useState([]);
  const [remarkData, setRemarkData] = useState([]);
  const [checkboxForAllRows, setCheckboxForAllRows] = useState(false)
  const [updateDenailDetails, setUpdateDenialdetails] = useState({
    Adj_Code: "",
    Note: '',
    AssignedTo: "",
    WhatsNeeded: "",
    ActionTaken: "",
    Redenied: false,
    Remark: "",
    DueDate: "",
    id: [],
    denialRows: []
  });
  const [openNotePopup, setOpenNotePopup] = useState(false);
  const [noteRequired, setNoteRequired] = useState({
    visible: false,
    tagName: "",
  });
  const handleNoteRequired = () => setNoteRequired(!noteRequired.visible);
  const [optionSelector, setOptionSelector] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState([]);
  const [selectedColumnDataCopy, setSelectedColumnDataCopy] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [filterKey, setFilterKey] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchData, setSearchData] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showCheckedValues, setShowCheckedValues] = useState(false);
  const [filterData, setFilterData] = useState({
    EncounterID: [],
    ServiceLocationName: [],
    Code: [],
    ServiceStartDate: [],
    SchedulingProviderName: [],
    PrimaryInsurancePlanName: [],
    EncounterDiagnosisID1: [],
    PatientName: [],
  });
  const [practiceId, setPracticeId] = useState("");
  const assigntoHint = React.useRef("");
  const autoCAssignRef = React.useRef(null);
  const [assigntoValue, setAssigntoValue] = React.useState("");
  const remarkHint = React.useRef("");
  const autoCRemarkCRef = React.useRef(null);
  const [remarkValue, setRemarkValue] = React.useState("");
  const [claimSelector, setClaimSelector] = useState(false);
  const [showDenialListByFilter, setShowDenialListByFilter] = useState("workList");
  const [allDenailData, setAllDenialData] = useState([]);
  const [labelValue, setLabelValue] = useState("Work List");
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showCancelLoader, setShowCancelLoader] = useState(false);

  const [denailFromAndToDate, setDenailFromAndToDate] = useState(
    { toDate: null, fromDate: null }
  );
  const [goBackCheckbox, setGoBackCheckbox] = useState('');

  const [encounterCount, setEncounterCount] = useState('');
  const [filterEncounterCount, setFilterEncounterCount] = useState(0);
  const [filterRows, setFilterRows] = useState(0);
  const [isfilter, setIsfilter] = useState(false);
  const [viewHistoryData, setViewHistoryData] = useState({});
  const [viewHistoryPage, setViewHistoryPage] = useState(0);
  const handleRemovePopup = () => setShowRemovePopup(!showRemovePopup);
  let [practiceIdFromSession, setPracticeIdFromSession] = useState("" + JSON.parse(sessionStorage.getItem('practice'))?.id);
  const [isAllPracticeSelected, setIsAllPracticeSelected] = useState(false)
  let roleData = JSON.parse(sessionStorage?.getItem('userDetail'))
  let practice = JSON.parse(sessionStorage.getItem("practice"))?.id
  let DenialCronLastUpdated = JSON.parse(sessionStorage.getItem("practice"))?.DenialCronLastUpdated
  const [handlePracticeChangeByNotReviewPage, setHandlePracticeChangeByNotReviewPage] = useState(() => () => { });

  // useEffect(() => {
  //   // web socket implementation
  //   try {
  //     socket.on('updateDenialRows', (data) => {
  //       if (data.success === true) {
  //         if (clientKey === data.clientKey && data.practiceId === practiceIdFromSession) {
  //           if (data.data.length) {
  //             if (data.actionTaken) {
  //               setDenialListAllRows((item) => {
  //                 return item.filter(row => {
  //                   let updatedItem = data.data.find(updatedRow => updatedRow === row.id)
  //                   if (updatedItem)
  //                     return false
  //                   else
  //                     return true
  //                 })
  //               })
  //               setDenialListCopy((item) => {
  //                 return item.filter(row => {
  //                   let updatedItem = data.data.find(updatedRow => updatedRow === row.id)
  //                   if (updatedItem)
  //                     return false
  //                   else
  //                     return true
  //                 })
  //               })
  //             } else {
  //               setDenialListAllRows((item) => {
  //                 return item.map(row => {
  //                   let updatedItem = data.data.find(updatedRow => updatedRow.id === row.id)
  //                   if (updatedItem)
  //                     return updatedItem
  //                   else
  //                     return row
  //                 })
  //               })
  //               setDenialListCopy((item) => {
  //                 return item.map(row => {
  //                   let updatedItem = data.data.find(updatedRow => updatedRow.id === row.id)
  //                   if (updatedItem)
  //                     return updatedItem
  //                   else
  //                     return row
  //                 })
  //               })
  //             }
  //           }
  //         }
  //       }
  //     })
  //   } catch (error) {
  //     console.log('Socket connection error on denial page')
  //   }
  // }, [denialListCopy])

  // logic to search encounters by dropdown selection

  const handleSelectChange = (e) => {
    setSelectedColumnData([])
    setSelectedColumnDataCopy([])
    let { value } = e.target;
    let searchDataKey = denialSearchItems?.find(item => item?.key == value)?.data
    setSearchKey(value);
    setSearchName(denialSearchItems.find(item => item.key == value)?.value)
    setSearchData(denialSearchItems.find(item => item.key == value)?.data)
    setShowSearch(true)
    setShowCheckedValues(false)
    setCheckboxValues(filterData[searchDataKey] ? filterData[searchDataKey] : [])
    handleDropdownData(value);
  }
  const handleDropdownData = (type) => {
    if (type === "dueDate") {
      setSelectedColumnData(dueDateData.map(item => item.label))
      setSelectedColumnDataCopy(dueDateData.map(item => item.label))
    }
    else if (type === "issueType") {
      setSelectedColumnData(issueTypes.map(item => item.value))
      setSelectedColumnDataCopy(issueTypes.map(item => item.value))
    }
    else if (type === "redenied") {
      setSelectedColumnData(redeniedData.map(item => item))
      setSelectedColumnDataCopy(redeniedData.map(item => item))
    } else {
      setApiLoading(true);
      let body_data = {
        label: type,
        labelValue: labelValue
      }
      API.post('searchByColumnValuesInDM', body_data).then((res) => {
        let data = res.data.data;
        if (type == "assignedTo" || type == "whatsNeeded") data.unshift("Unassigned")
        setApiLoading(false)
        setSelectedColumnData(data);
        setSelectedColumnDataCopy(data)
      }).catch(err => {
        console.error(err);
      })
    }
  }
  const searchFilterValues = (value) => {
    setFilterKey(value);
    let searchResult = selectedColumnDataCopy.filter((item) => {
      if (
        item.toUpperCase().indexOf(value.toUpperCase()) !== -1
      ) {
        return item;
      }
    });
    setSelectedColumnData(searchResult);
  };

  // function to handle checkbox values for filter
  const handleCheckboxValues = (e) => {
    const { value } = e.target;
    let selectedVal = value;
    const newSearchData = filterData
    if (!checkboxValues.includes(selectedVal)) {
      setCheckboxValues([...checkboxValues, selectedVal]);
      newSearchData[searchData] = [...checkboxValues, selectedVal]
      setFilterData(newSearchData);
    } else {
      const newFilterObj = checkboxValues.filter((index) => {
        return index !== selectedVal;
      })
      setCheckboxValues(newFilterObj)
      newSearchData[searchData] = newFilterObj ? newFilterObj : []
      setFilterData(newSearchData);
    }
  }

  // function to handle go back
  const handleGoBack = () => {
    setShowCheckedValues(true);
    setShowSearch(false);
    setSearchKey('')
  }

  // function to handle go back checkbox selection
  const handleGoBackCheckbox = (title, values) => {
    const newFilterData = filterData[title]?.filter(item => item != values)
    const newFilterObj = filterData
    newFilterObj[title] = newFilterData ? newFilterData : []
    setFilterData(newFilterObj);
    setGoBackCheckbox(`${title}: ${values}`)
  }

  const dateCompare = (key, dateVal) => {
    // console.log(key, dateVal)
    let date1
    let futureDate
    let compareElement
    filterData[key]?.forEach(element => {
      if (element === "Missing") {
        compareElement = compareElement ? (compareElement || dateVal === "" || dateVal == null || dateVal == undefined) : (dateVal === "" || dateVal == null || dateVal == undefined)
      }
      if (element === "Late") {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set to midnight for accurate comparison
        const todayTimestamp = today.getTime();
        const itemDate = new Date(dateVal);
        itemDate.setHours(0, 0, 0, 0);
        const itemTimestamp = itemDate.getTime();

        // Check if the item's date is strictly less than today's date
        const isInRange = itemTimestamp < todayTimestamp;
        // date1 = new Date().getTime();
        compareElement = compareElement ? (compareElement || isInRange) : isInRange;

        // date1 = new Date().getTime();
        // compareElement = compareElement ? (compareElement || (new Date(dateVal).getTime() < date1)) : ((new Date(dateVal).getTime() < date1))
      }
      if (element === "Today") {
        date1 = new Date();
        date1.setHours(0, 0, 0, 0);
        // date1 = new Date().getTime()
        // console.log(date1, new Date(dateVal).getTime())
        // console.log(new Date(date1).toLocaleDateString(), new Date(new Date(dateVal).getTime()).toLocaleDateString())
        compareElement = compareElement ? (compareElement || (new Date(dateVal).setHours(0, 0, 0, 0) == date1.getTime())) : (new Date(dateVal).setHours(0, 0, 0, 0) == date1.getTime())
      }
      if (element === "Tomorrow") {
        date1 = new Date()
        date1.setDate(date1.getDate() + 1)
        date1.setHours(0, 0, 0, 0);
        // console.log(new Date(date1).getTime(), new Date(dateVal).getTime())
        // console.log(new Date(new Date(date1).getTime()).toLocaleDateString(), new Date(new Date(dateVal).getTime()).toLocaleDateString())
        compareElement = compareElement ? (compareElement || (new Date(dateVal).setHours(0, 0, 0, 0) == date1.getTime())) : (new Date(dateVal).setHours(0, 0, 0, 0) == date1.getTime())
      }
      // if (element === "This Week") {
      //   date1 = new Date()
      //   const dayOfWeek = date1.getDay(); // Sunday is 0, Monday is 1, etc.
      //   const diff = date1.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust when day is Sunday
      //   const monday = new Date(date1.setDate(diff - 1));

      //   // console.log("date filter", dayOfWeek, diff, monday, date1.getDate())

      //   // date1.setDate(date1.getDate())
      //   date1.setDate(monday.getDate())
      //   // console.log("date1", date1)
      //   futureDate = new Date()
      //   futureDate.setDate(date1.getDate() + 7)
      //   // console.log("futureDate", futureDate)
      //   compareElement = compareElement ? (compareElement || ((new Date(dateVal).getTime()) <= new Date(futureDate).getTime()) && ((new Date(dateVal).getTime()) >= new Date(date1).getTime())) : ((new Date(dateVal).getTime()) <= new Date(futureDate).getTime()) && ((new Date(dateVal).getTime()) >= new Date(date1).getTime())
      // }

      if (element === "This Week") {
        const today = new Date();

        // Get the start of the week (Monday)
        const dayOfWeek = today.getDay(); // Sunday is 0, Monday is 1, etc.
        const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday (0) to 6, others to dayOfWeek - 1

        date1 = new Date(today);
        date1.setDate(today.getDate() - daysFromMonday);
        date1.setHours(0, 0, 0, 0); // Set to start of Monday

        // Get the end of the week (Sunday)
        futureDate = new Date(date1);
        futureDate.setDate(date1.getDate() + 6); // Monday + 6 days = Sunday
        futureDate.setHours(23, 59, 59, 999); // Set to end of Sunday

        // Check if dateVal falls within this week (inclusive of both Monday and Sunday)
        const dateToCheck = new Date(dateVal);
        const isInRange = dateToCheck >= date1 && dateToCheck <= futureDate;

        // console.log(date1, dateToCheck, futureDate)

        compareElement = compareElement ? (compareElement || isInRange) : isInRange;
      }

      // if (element === "Next Week") {
      //   date1 = new Date()
      //   const dayOfWeek = date1.getDay(); // Sunday is 0, Monday is 1, etc.
      //   const diff = date1.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust when day is Sunday
      //   const monday = new Date(date1.setDate(diff - 1));
      //   date1.setDate(monday.getDate() + 7)
      //   // date1.setDate(date1.getDate() + 7)
      //   futureDate = new Date()
      //   futureDate.setDate(monday.getDate() + 14)
      //   // futureDate.setDate(futureDate.getDate() + 14)
      //   compareElement = compareElement ? (compareElement || ((new Date(dateVal).getTime()) <= new Date(futureDate).getTime()) && ((new Date(dateVal).getTime()) >= new Date(date1).getTime())) : ((new Date(dateVal).getTime()) <= new Date(futureDate).getTime()) && ((new Date(dateVal).getTime()) >= new Date(date1).getTime())
      // }

      if (element === "Next Week") {
        const today = new Date();

        // Get the start of next week (Monday)
        const dayOfWeek = today.getDay(); // Sunday is 0, Monday is 1, etc.
        const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday (0) to 6, others to dayOfWeek - 1

        date1 = new Date(today);
        date1.setDate(today.getDate() - daysFromMonday + 7); // Go to this Monday, then add 7 days for next Monday
        date1.setHours(0, 0, 0, 0); // Set to start of Monday

        // Get the end of next week (Sunday)
        futureDate = new Date(date1);
        futureDate.setDate(date1.getDate() + 6); // Monday + 6 days = Sunday
        futureDate.setHours(23, 59, 59, 999); // Set to end of Sunday

        // Check if dateVal falls within next week (inclusive of both Monday and Sunday)
        const dateToCheck = new Date(dateVal);
        const isInRange = dateToCheck >= date1 && dateToCheck <= futureDate;

        compareElement = compareElement ? (compareElement || isInRange) : isInRange;
      }

      if (element === "Future") {
        date1 = new Date()
        const dayOfWeek = date1.getDay(); // Sunday is 0, Monday is 1, etc.
        const diff = date1.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Adjust when day is Sunday
        const monday = new Date(date1.setDate(diff - 1));
        date1.setDate(monday.getDate() + 14)
        // date1.setDate(date1.getDate() + 14)
        compareElement = compareElement ? (compareElement || new Date(dateVal).getTime() > new Date(date1).getTime()) : (new Date(dateVal).getTime() > new Date(date1).getTime())
      }
      else {
        // compaireElement = true
      }
    });
    return compareElement
  }

  const filterTable = async () => {
    let keys = Object.keys(filterData)
    let finalResult = allDenialList;
    await keys?.map(key => {
      if (filterData[key]?.length != 0) {
        if (key === 'DueDate') {
          finalResult = finalResult?.filter(item => dateCompare(key, item[key]))
        }
        else if (key === "issueType") {
          finalResult = finalResult?.filter(item => filterData[key]?.includes(item[key]))
        }
        else if (filterData[key] == "Unassigned") {
          if (key == "AssignedTo") {
            finalResult = finalResult?.filter(item => item.userName == null || item.userName == "")
          } else if (key == "WhatsNeeded") {
            finalResult = finalResult?.filter(
              (item) => item.WhatsNeeded == null || item.WhatsNeeded == ""
            );
          }
        }
        else if (key == "AssignedTo" && filterData[key] != "Unassigned") {
          finalResult = finalResult?.filter((item) =>
            filterData[key]?.includes(item.userName)
          );
        }
        else if (key == "Redenied") {
          if (filterData[key] == "No") {
            finalResult = finalResult?.filter(item => item.Redenied == false || item.Redenied == null)
          } else if (filterData[key] == "Yes") {
            finalResult = finalResult?.filter(item => item.Redenied == true)
          }
        } else {
          finalResult = finalResult?.filter(item => filterData[key]?.includes(item[key]))
        }
      }
    })
    let filterCount = finalResult.map(item => item.EncounterID)
    setDenialList(finalResult)
    setIsfilter(true)
    setFilterRows(filterCount?.length)
    setFilterEncounterCount(new Set(filterCount).size)
    setOptionSelector(false)
    setShowSearch(false);
    setShowCheckedValues(true);
    localStorage.setItem('denialFilter', JSON.stringify(filterData));
  }

  // function to clear filter values
  const clearFilter = () => {
    setOptionSelector(false)
    setShowSearch(false);
    setShowCheckedValues(false)
    setSearchKey('')
    setFilterKey('')
    setIsfilter(false)
    setCheckboxValues([])
    setApiLoading(false);
    getDenialWorklist(practiceId);
    setFilterData({
      EncounterID: [],
      ServiceLocationName: [],
      Code: [],
      ServiceStartDate: [],
      SchedulingProviderName: [],
      PrimaryInsurancePlanName: [],
      EncounterDiagnosisID1: [],
      PatientName: [],
      DueDate: []
    })
    setFilterEncounterCount(0)
    localStorage.removeItem("denialFilter");
  }

  const selectHandler = (e) => {
    setOptionSelector(!optionSelector)
    setSearchKey('')
    setSelectedColumnData([])
    setShowSearch(false)
    setApiLoading(false)
  }

  const claimActions = async () => {
    let result = await API.get("/getClaimActions/denial")
    console.log(result, 'claimActions')
    let actionTakenItems = [], whatsNeededItems = []
    result.data.forEach((item) => {
      if (item.filterType == 'actionTaken') {
        actionTakenItems.push({
          key: item.id,
          value: item.items
        })
      } else {
        whatsNeededItems.push({
          key: item.id,
          value: item.items
        })
      }
    })
    setActionTakenDenial(actionTakenItems);
    setWhatsNeededDenial(whatsNeededItems)
  }

  useEffect(() => {
    setDenailFromAndToDate(
      sessionStorage.getItem("denailFromAndToDate")
        ? JSON.parse(sessionStorage.getItem("denailFromAndToDate"))
        : { toDate: null, fromDate: null }
    );
    getDenialWorklist();
    getAssignToDetails();
    getRemarkData();
    claimActions()
  }, []);

  useEffect(() => {
    getAllDenialWorklist();
  }, [practice]);

  useEffect(async () => {
    let storedFilterData = (JSON.parse(localStorage.getItem('denialFilter')))
    // let keys = Object.keys(filterData)
    let newFilterData = storedFilterData ? storedFilterData : filterData;
    let keys = Object.keys(newFilterData)
    let finalResult = allDenialList
    await keys?.map(key => {
      if (newFilterData[key]?.length != 0) {
        if (key === 'DueDate') {
          finalResult = finalResult?.filter(item => dateCompare(key, item[key]))
        }
        else if (key === "issueType") {
          finalResult = finalResult?.filter(item => newFilterData[key]?.includes(item[key]))
        }
        else if (newFilterData[key] == "Unassigned") {
          if (key == "AssignedTo") {
            finalResult = finalResult?.filter(item => item.userName == null || item.userName == "")
          } else if (key == "WhatsNeeded") {
            finalResult = finalResult?.filter(
              (item) => item.WhatsNeeded == null || item.WhatsNeeded == ""
            );
          }
        }
        else if (key == "AssignedTo" && newFilterData[key] != "Unassigned") {
          finalResult = finalResult?.filter((item) =>
            newFilterData[key]?.includes(item.userName)
          );
        }
        else if (key == "Redenied") {
          if (newFilterData[key] == "No") {
            finalResult = finalResult?.filter(item => item.Redenied == false || item.Redenied == null)
          } else if (newFilterData[key] == "Yes") {
            finalResult = finalResult?.filter(item => item.Redenied == true)
          }
        } else {
          finalResult = finalResult?.filter(item => newFilterData[key]?.includes(item[key]))
        }
      }
    })
    let filterCount = finalResult.map(item => item.EncounterID)
    setDenialList(finalResult)
    setIsfilter(true)
    setFilterRows(filterCount?.length)
    setFilterEncounterCount(localStorage.getItem('denialFilter') ? new Set(filterCount).size : 0)
    setShowCheckedValues(localStorage.getItem('denialFilter') ? true : false);
  }, [allDenialList, practice]);

  // function to get denial worksheet list
  const getAllDenialWorklist = () => {
    setShowLoader(true);
    setShowCancelLoader(false);
    let chargesTimer = setTimeout(() => setShowCancelLoader(!showCancelLoader), 15000)
    API.get("getDenialData").then((res) => {
      clearTimeout(chargesTimer);
      let data = res.data.data;
      setAllDenialList(data);
      setDenialListAllRows(data)
      setPracticeId(data.find((item) => item.PracticeID));
      setEncounterCount(res.data.uniqueRows)
      setShowLoader(false)
    }).catch(err => {
      console.error(err);
      setShowLoader(false);
      setShowCancelLoader(false);
    });
  };

  const getRemarkData = () => {
    API.get("getRemarkData")
      .then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          setRemarkData(data);
        }
      })
      .catch((error) => {
        NotificationManager.error(
          "Something Went wrong!",
          "Failure!",
          3000
        );
      });
  };

  const getAssignToDetails = () => {
    API.get("/getAssignToUsers")
      .then((result) => {
        if (result.data.success === true && result.data.userList.length) {
          let userArr = ["Danish", "Pappu", "puneet", "Monu", "Saurabh"]
          let userList = result.data.userList.filter(item => !userArr.includes(item.first_name));
          setAssignTo(userList);
          // setAssignTo(result.data.userList);
        }
      })
      .catch((error) => {
        NotificationManager.error(
          "Something Went wrong!",
          "Failure!",
          3000
        );
      });
  };

  const handleCheckboxClick = (event, row = null) => {

    let incomingVal = event.target.value;
    switch (event.target.name) {
      case "checkboxForAllRows":
        setCheckboxForAllRows(item => !item)
        if (incomingVal === 'false') {
          setUpdateDenialdetails((items) => {
            return { ...items, id: row.map(eml => eml.id), denialRows: [...row] }
          })
        } else {
          setUpdateDenialdetails((items) => {
            return { ...items, id: [], denialRows: [] }
          })
        }
        break;


      // case "userCheckbox":
      //   incomingVal = +incomingVal;
      //   console.log("incomingVal", incomingVal)
      //   let duplicateEncounter = (denialListAllRows || []).filter(item => (item.EncounterID === row.EncounterID && item.id !== incomingVal));
      //   console.log("duplicateEncounter", duplicateEncounter)
      //   console.log("row", row)
      //   if (!updateDenailDetails.id.includes(incomingVal)) {
      //     // let allRows = [...updateDenailDetails.denialRows, row, ...duplicateEncounter]

      //     // Combine all arrays into one first
      //     const allRows = [
      //       ...updateDenailDetails.denialRows,
      //       row,
      //       ...duplicateEncounter
      //     ];

      //     // Create a Map with 'id' as the key. Duplicate keys are ignored.
      //     const uniqueRowsMap = new Map(allRows.map(obj => [obj.id, obj]));

      //     // Convert the Map values back to an array
      //     const uniqueRows = [...uniqueRowsMap.values()];

      //     console.log("uniqueRows", uniqueRows)

      //     let idsArr = duplicateEncounter.map((item => item.id))
      //     console.log("idsArr", idsArr)
      //     idsArr.push(incomingVal)
      //     let allIds = [...updateDenailDetails.id, ...idsArr]
      //     console.log("allIds", allIds)
      //     setUpdateDenialdetails((item) => {
      //       return { ...item, id: allIds, denialRows: uniqueRows };
      //     });
      //   } else {
      //     if (duplicateEncounter.length) {

      //       let idsArr = []
      //       // let idsArr = duplicateEncounter.map((item => item.id))
      //       console.log("duplicateEncounterduplicateEncounter", incomingVal)
      //       idsArr.push(incomingVal)
      //       setUpdateDenialdetails((item) => {
      //         console.log("fghsbdhfjgbdhfj", item)
      //         return {
      //           ...item,
      //           id: item.id.filter((ids) => !idsArr.includes(ids)),
      //           denialRows: item.denialRows.filter((item => !idsArr.includes(item.id)))
      //         };
      //       });
      //     } else {
      //       setUpdateDenialdetails((item) => {
      //         return {
      //           ...item,
      //           id: item.id.filter((ids) => ids !== incomingVal),
      //           denialRows: item.denialRows.filter(item => item.id !== incomingVal)
      //         };
      //       });
      //     }
      //   }
      //   break;

      case "userCheckbox":
        incomingVal = +incomingVal;
        // This filter is only needed for the selection logic, not for deselection.
        const encountersToSelect = (denialListAllRows || []).filter(item => item.EncounterID === row.EncounterID);

        if (!updateDenailDetails.id.includes(incomingVal)) {
          // --- SELECTION LOGIC ---
          // Get all the IDs and rows for the selected EncounterID
          const idsToSelect = encountersToSelect.map(item => item.id);

          // Combine existing and new IDs, and create a Set to get unique IDs
          const allIds = [...updateDenailDetails.id, ...idsToSelect];
          const uniqueIds = [...new Set(allIds)];

          // Combine all relevant rows into one list, removing duplicates
          const allRows = [...updateDenailDetails.denialRows, ...encountersToSelect];
          const uniqueRowsMap = new Map(allRows.map(obj => [obj.id, obj]));
          const uniqueRows = [...uniqueRowsMap.values()];
          setUpdateDenialdetails(item => ({
            ...item,
            id: uniqueIds,
            denialRows: uniqueRows,
          }));

        } else {
          // --- DESELECTION LOGIC ---
          // Only deselect the specific row with the matching ID.
          setUpdateDenialdetails(item => ({
            ...item,
            id: item.id.filter(id => id !== incomingVal),
            denialRows: item.denialRows.filter(denialRow => denialRow.id !== incomingVal),
          }));
        }
        break;


      case "denialNote":
        setUpdateDenialdetails((item) => {
          return { ...item, Note: incomingVal };
        });
        break;
      case "WhatsNeeded":
        setUpdateDenialdetails((item) => {
          return { ...item, WhatsNeeded: incomingVal };
        });
        break;
      case "Action":
        setUpdateDenialdetails((item) => {
          return { ...item, ActionTaken: incomingVal };
        });
        break;
      case "redenied":
        setUpdateDenialdetails((item) => {
          return { ...item, Redenied: incomingVal };
        });
        break;
      case "adjCode":
        setUpdateDenialdetails((item) => {
          return { ...item, Adj_Code: incomingVal };
        });
        break;
      default:
        console.log("wrong key selection");
    }
  };

  const resetState = (stateName) => {
    const autoCRemarkCRefEle = autoCRemarkCRef?.current?.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
    if (autoCRemarkCRefEle) {
      autoCRemarkCRefEle.click();
    }
    const autoCautoCAssignRefEle = autoCAssignRef?.current?.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
    if (autoCautoCAssignRefEle) {
      autoCautoCAssignRefEle.click();
    }
    if (stateName === "resetButtonHandle") {
      assigntoHint.current = "";
      remarkHint.current = "";
      setAssigntoValue("");
      setRemarkValue("");
      setUpdateDenialdetails(item => {
        return {
          Adj_Code: "",
          Note: '',
          AssignedTo: "",
          WhatsNeeded: "",
          ActionTaken: "",
          Redenied: false,
          Remark: "",
          DueDate: "",
          id: item.id,
          denialRows: []
        }
      });
    }
    if (stateName === "updateDenailDetails") {
      setCheckboxForAllRows(false)
      assigntoHint.current = "";
      remarkHint.current = "";
      setAssigntoValue("");
      setRemarkValue("");
      setUpdateDenialdetails({
        Adj_Code: "",
        Note: '',
        AssignedTo: "",
        WhatsNeeded: "",
        ActionTaken: "",
        Redenied: false,
        Remark: "",
        DueDate: "",
        id: [],
        denialRows: []
      });
    }

  };

  const updateDenailRow = () => {
    if (updateDenailDetails.ActionTaken !== "") {
      if (updateDenailDetails.Note.length === 0) {
        setNoteRequired({
          tagName: 'note',
          visible: true,
        });
        return;
      }
      if (updateDenailDetails.ActionTaken == "Remove" || updateDenailDetails.ActionTaken == "1") {
        handleRemovePopup();
        return;
      }
      if (updateDenailDetails.WhatsNeeded === "" || updateDenailDetails.Remark === "" || updateDenailDetails.Adj_Code === "") {
        let remarkCodeCheck = false, adjCodeCheck = false, whatsNeededCheck = false
        if (updateDenailDetails.Adj_Code === "") {
          if (updateDenailDetails.denialRows.filter((code) => {
            return code.Adj_Code === '' || code.Adj_Code === null || code.Adj_Code === undefined
          }).length) {
            setNoteRequired({
              tagName: "Adjustment Code",
              visible: true,
            });
            return;
          } else {
            remarkCodeCheck = true
          }
        } else {
          remarkCodeCheck = true
        }
        if (updateDenailDetails.Remark === "") {
          let remarkCodeArray = remarkData.map(code => code.RemarkCode);
          let dropdownEmptyCheck = updateDenailDetails.denialRows.filter((code) => {
            return code.Remark === '' || code.Remark === null || code.Remark === undefined
          }).length;
          let checkRemarkInRows = updateDenailDetails.denialRows.filter((code) => {
            return remarkCodeArray.indexOf("" + code.Remark) === -1
          }).length;

          if (dropdownEmptyCheck) {
            setNoteRequired({
              tagName: "Remark",
              visible: true,
            });
            return;
          }
          if (checkRemarkInRows) {
            NotificationManager.error(
              "Wrong Remark Code",
              "Failure!",
              3000
            );
            return;
          } else {
            adjCodeCheck = true;
          }
        } else {
          adjCodeCheck = true;
        }
        if (updateDenailDetails.WhatsNeeded === "") {
          let whatsNeededEmptyCheck = updateDenailDetails.denialRows.filter((code) => {
            return code.WhatsNeeded === '' || code.WhatsNeeded === null || code.WhatsNeeded === undefined
          }).length;
          if (whatsNeededEmptyCheck) {
            setNoteRequired({
              tagName: "What's Needed",
              visible: true,
            });
            return;
          } else {
            whatsNeededCheck = true
          }
        } else {
          whatsNeededCheck = true
        }

        if (whatsNeededCheck && adjCodeCheck && remarkCodeCheck) {
          updateData();
        }
      } else if (updateDenailDetails.id.length === 0) {
        NotificationManager.error(
          "Please select atleast one row to continue!",
          "Failure!",
          3000
        );
      } else {
        updateData();
      }
    } else {
      if (updateDenailDetails.id.length === 0) {
        NotificationManager.error(
          "Please select atleast one row to continue!",
          "Failure!",
          3000
        );
      } else {
        updateData();
      }
    }
  };

  const updateData = () => {
    // need to remove denialRows from payload
    localStorage.setItem("undoData", JSON.stringify(updateDenailDetails.denialRows))
    let { denialRows, ...restpauload } = updateDenailDetails;
    API.put("/updateDenialData", restpauload).then((result) => {
      if (result.data.success === true) {
        NotificationManager.success(
          "Rows updated successfully",
          "Successful!",
          2000
        );
        if (updateDenailDetails.ActionTaken) {
          setEncounterCount(encCount => encCount - (new Set(updateDenailDetails.denialRows.map(item => item.EncounterID))).size)
          // socket.emit('updateDenialRows', {
          //   clientKey: getClientKey(),
          //   practiceId: practiceIdFromSession,
          //   ids: updateDenailDetails.id,
          //   actionTaken: updateDenailDetails.ActionTaken
          // })
          showCheckedValues ? getAllDenialWorklist() : getDenialWorklist();
          resetState("updateDenailDetails");
        } else {
          showCheckedValues ? getAllDenialWorklist() : getDenialWorklist();
          // socket.emit('updateDenialRows', {
          //   clientKey: getClientKey(),
          //   practiceId: practiceIdFromSession,
          //   ids: updateDenailDetails.id
          // })
          resetState("updateDenailDetails");
        }
      }
    });
  };

  // function to undo last action
  const undoLastAction = () => {
    let undoData = JSON.parse(localStorage.getItem('undoData'))
    API.post('undoDenialData', undoData).then(res => {
      console.log(res)
      getDenialWorklist();
    })
  }

  const statusDropdownHandler = (e) => {
    setClaimSelector(!claimSelector);
  };

  const handleClaimsDropdown = async (e) => {
    setShowDenialListByFilter(e.target.value);
    setLabelValue(
      denailFilterDropdown.filter((item) => item.key === e.target.value)[0]
        .value
    );
    setDenialList(null);
    setClaimSelector(!claimSelector);
    if (e.target.value === "workList") {
      getDenialWorklist();
    }
  };

  const handleDateChange = (event, date_type) => {
    if (date_type === "DENIAL_FROM") {
      setDenailFromAndToDate((item) => {
        return { ...item, fromDate: event };
      });
    }
    if (date_type === "DENIAL_TO") {
      setDenailFromAndToDate((item) => {
        return { ...item, toDate: event };
      });
    }
  };

  useEffect(() => {
    if (updateDenailDetails.id.length) {
      if (!checkboxForAllRows)
        setCheckboxForAllRows(true)
    } else
      setCheckboxForAllRows(false)
  }, [updateDenailDetails.id])

  useEffect(() => {
    applyToAndFromDateFilter();
  }, [denailFromAndToDate, denialListAllRows]);

  function applyToAndFromDateFilter() {
    if (denailFromAndToDate.toDate && denailFromAndToDate.fromDate) {
      sessionStorage.setItem(
        "denailFromAndToDate",
        JSON.stringify(denailFromAndToDate)
      );
      let data = denialListAllRows.filter((item) => {
        var denailDate = new Date(item.Denial_Date);
        var fromDate = new Date(denailFromAndToDate.fromDate);
        var toDate = new Date(denailFromAndToDate.toDate);
        return denailDate > fromDate && denailDate < toDate; // item.Denial_Date > denailFromAndToDate.fromDate && item.Denial_Date < denailFromAndToDate.toDate
      });
      setDenialList(data);
    } else if (
      denailFromAndToDate.toDate &&
      denailFromAndToDate.fromDate === null
    ) {
      sessionStorage.setItem(
        "denailFromAndToDate",
        JSON.stringify(denailFromAndToDate)
      );
      let data = denialListAllRows.filter((item) => {
        var denailDate = new Date(item.Denial_Date);
        var toDate = new Date(denailFromAndToDate.toDate);
        return denailDate < toDate;
      });
      setDenialList(data);
    } else if (
      denailFromAndToDate.fromDate &&
      denailFromAndToDate.toDate === null
    ) {
      sessionStorage.setItem(
        "denailFromAndToDate",
        JSON.stringify(denailFromAndToDate)
      );
      let data = denialListAllRows.filter((item) => {
        var denailDate = new Date(item.Denial_Date);
        var fromDate = new Date(denailFromAndToDate.fromDate);
        return denailDate > fromDate;
      });
      setDenialList(data);
    } else if (
      denailFromAndToDate.fromDate === null &&
      denailFromAndToDate.toDate === null
    ) {
      setDenialList(denialListAllRows)
      sessionStorage.setItem(
        "denailFromAndToDate",
        JSON.stringify(denailFromAndToDate)
      );
    }
  }

  const handleNotePopup = () => {
    if (updateDenailDetails.id.length === 0) {
      NotificationManager.error('Please select atleast one row to continue!', 'Failure!', 3000);
    } else {
      setOpenNotePopup(!openNotePopup);
      const viewData = denialList?.find(item => item.id === updateDenailDetails.id[0])
      // setViewHistoryPage(viewHistoryPage + 1)
      setViewHistoryData(viewData)
    }
  }
  const handleClickNextForView = () => {
    const currectPage = viewHistoryPage + 1
    const viewData = denialList?.find(item => item.id === updateDenailDetails.id[currectPage])
    setViewHistoryPage(currectPage)
    setViewHistoryData(viewData)
  }
  const handleClickPreviousForView = () => {
    const currectPage = viewHistoryPage - 1
    const viewData = denialList?.find(item => item.id === updateDenailDetails.id[currectPage])
    setViewHistoryPage(currectPage)
    setViewHistoryData(viewData)
  }

  // function to export denials to excel
  // const exportDenialWorklist = () => {
  //   let practice = JSON.parse(sessionStorage.getItem("practice"))
  //   let exportedExcelName;
  //   if (practice == "all") {
  //     exportedExcelName = "All Practices-Denials-Worklist";
  //   } else {
  //     exportedExcelName = `${practice?.practiceAcronym}-Denials-Worklist`;
  //   }
  //   let exportedDenialData = [];
  //   denialList.map(item => {
  //     const newItem = {};
  //     newItem["PracticeName"] = item.PracticeName;
  //     newItem["CustomerID"] = Number(item.CUSTOMERID);
  //     newItem["ClaimID"] = Number(item.CLAIMID);
  //     newItem["EncounterID"] = Number(item.EncounterID);
  //     newItem["PatientID"] = Number(item.PATIENTID);
  //     newItem["PatientName"] = item.PatientName;
  //     newItem["DOB"] = formatToMMDDYYYY(item.DOB);
  //     newItem["ServiceStartDate"] = formatToMMDDYYYY(item.ServiceStartDate);
  //     newItem["RenderingProviderID"] = Number(item.RENDERING_PROVIDER_ID);
  //     newItem["RenderingProviderName"] = item.RENDERING_PROVIDER_NAME;
  //     newItem["SchedulingProviderID"] = Number(item.SCHEDULING_PROVIDER_ID);
  //     newItem["SchedulingProviderName"] = item.SchedulingProviderName;
  //     newItem["ServiceLocationName"] = item.ServiceLocationName;
  //     newItem["InsPhone"] = formatPhoneNumber(item.InsPhone);
  //     newItem["PolicyNumber"] = item.PolicyNumber;
  //     newItem["BilledTo"] = item.Billed_to;
  //     newItem["InsPlanID"] = Number(item.InsPlanID);
  //     newItem["Code"] = item.Code;
  //     newItem["Mod1"] = item.Mod;
  //     newItem["DXC1"] = item.DXC1;
  //     newItem["TotalCharge"] = Number(item.Total_Charge);
  //     newItem["Balance"] = Number(item.Balance);
  //     newItem["AdjCode"] = item.Adj_Code;
  //     newItem["Remark"] = item.Remark;
  //     newItem["Advice"] = item.ADVICE;
  //     newItem["Issue Type"] = item.issueType;
  //     newItem["DenialDate"] = formatToMMDDYYYY(item.Denial_Date);
  //     newItem["PaymentID"] = Number(item.PAYMENTID);
  //     newItem["Status"] = showDenialListByFilter == "workList" ? "Worklist" : showDenialListByFilter == "completed" ? "Completed" : "Pending Worked Validation";
  //     newItem["Redenied"] = item.Redenied == false || item.Redenied == null ? "No" : "Yes";
  //     newItem["AssignedTo"] = item.userName;
  //     newItem["WhatsNeeded"] = item.WhatsNeeded;
  //     newItem["DueDate"] = formatToMMDDYYYY(item.DueDate);
  //     newItem["ActionTaken"] = item.ActionTaken;
  //     newItem["CompletedBy"] = item.CompletedBy;
  //     newItem["DateCompleted"] = item.DateCompleted;
  //     newItem["LastNote"] = item.Notes[0] != undefined ? item.Notes[0].NOTES : "";
  //     newItem["CreatedOn"] = item.created_at;
  //     newItem["UpdatedOn"] = item.updated_at;
  //     exportedDenialData.push(newItem);
  //   })
  //   // let denialWorklist = exportedDenialData;
  //   const worksheet = XLSX.utils.json_to_sheet(exportedDenialData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Denial Worklist");
  //   XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`);
  // };


  const exportDenialWorklist = () => {
    let practice = JSON.parse(sessionStorage.getItem("practice"))
    let exportedExcelName;
    if (practice == "all") {
      exportedExcelName = "All Practices-Denials-Worklist";
    } else {
      exportedExcelName = `${practice?.practiceAcronym}-Denials-Worklist`;
    }
    // const toExcelDateMidnightUTC = (formattedDate) => {
    //   let value;
    //   if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedDate)) {
    //     value = formattedDate;
    //   } else {
    //     value = formatToMMDDYYYY(formattedDate);
    //   }
    //   if (!value) return null;
    //   const d = new Date(value);
    //   const utcDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    //   const epoch = new Date(Date.UTC(1899, 11, 30));
    //   return (utcDate - epoch) / (24 * 60 * 60 * 1000);
    // };

    // const toExcelDateMidnightUTC = (formattedDate) => {
    //   // 1. Ensure the formatted date is in a reliable format (e.g., "mm/dd/yyyy")
    //   let value = formattedDate;
    //   if (!/^\d{2}\/\d{2}\/\d{4}$/.test(formattedDate)) {
    //     value = formatToMMDDYYYY(formattedDate);
    //   }
    //   if (!value) return null;

    //   // 2. Parse the date string safely into its components
    //   const [month, day, year] = value.split('/').map(Number);

    //   // 3. Create a new Date object representing UTC midnight for that day
    //   // The Date.UTC() method returns the milliseconds since epoch,
    //   // so we can use it to correctly calculate the Excel date number.
    //   const utcMidnightMillis = Date.UTC(year, month - 1, day); // month - 1 because months are 0-indexed

    //   // 4. Calculate the Excel date number based on the Excel epoch
    //   const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    //   return (utcMidnightMillis - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
    // };

    // const toExcelDateMidnightUTC = (formattedDate) => {
    //   if (!formattedDate) return null;

    //   let date;
    //   // Check if the date string contains time information (indicated by 'T')
    //   if (formattedDate.includes('T')) {
    //     // For dates with time, create a Date object directly.
    //     // It will be parsed correctly with the timezone information.
    //     date = new Date(formattedDate);
    //   } else {
    //     // For date-only strings (like "2025-09-21"), construct it manually
    //     // to ensure it is treated as local midnight, not UTC midnight.
    //     const [year, month, day] = formattedDate.split('-').map(Number);
    //     date = new Date(year, month - 1, day); // month is 0-indexed
    //   }
    //   // Handle invalid dates
    //   if (isNaN(date.getTime())) {
    //     console.error('Invalid date received:', formattedDate);
    //     return null;
    //   }
    //   // Calculate the Excel date number based on the Excel epoch
    //   const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    //   return (date.getTime() - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
    // };


    const toExcelDateMidnightUTC = (formattedDate) => {
      if (!formattedDate) return null;

      let date;

      // Check if the date string includes time information (indicated by 'T' or a space)
      if (formattedDate.includes('T') || formattedDate.includes(' ')) {
        // If a time component exists, create a Date object and then zero out the time.
        date = new Date(formattedDate);
        if (isNaN(date.getTime())) {
          console.error('Invalid date received:', formattedDate);
          return null;
        }
        // Zero out the time components to get the start of the day in local time
        date.setHours(0, 0, 0, 0);

      } else {
        // For date-only strings (like "2025-09-21"), construct it manually
        // to ensure it is treated as local midnight, not UTC midnight.
        const [year, month, day] = formattedDate.split('-').map(Number);
        date = new Date(year, month - 1, day); // month is 0-indexed
      }

      // Handle invalid dates
      if (isNaN(date.getTime())) {
        console.error('Invalid date received:', formattedDate);
        return null;
      }

      // Create a new date at UTC midnight to perform the Excel number calculation
      // This is the most reliable way to prevent timezone shifts
      const utcMidnightMillis = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

      // Calculate the Excel date number based on the Excel epoch
      const excelEpoch = new Date(Date.UTC(1899, 11, 30));
      return (utcMidnightMillis - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
    };

    const exportColumns = [
      { key: "PracticeName" },
      { key: "CustomerID", type: "integer" },
      { key: "ClaimID", type: "integer" },
      { key: "EncounterID", type: "integer" },
      { key: "PatientID", type: "integer" },
      { key: "PatientName" },
      { key: "DOB", type: "date" },
      { key: "ServiceStartDate", type: "date" },
      { key: "RenderingProviderID", type: "integer" },
      { key: "RenderingProviderName" },
      { key: "SchedulingProviderID", type: "integer" },
      { key: "SchedulingProviderName" },
      { key: "ServiceLocationName" },
      { key: "InsPhone", type: "text" },
      { key: "PolicyNumber" },
      { key: "BilledTo" },
      { key: "InsPlanID", type: "integer" },
      { key: "Code" },
      { key: "TotalCharge", type: "decimal" },
      { key: "Balance", type: "decimal" },
      { key: "AdjCode" },
      { key: "Remark" },
      { key: "Advice" },
      { key: "Issue Type" },
      { key: "DenialDate", type: "date" },
      { key: "PaymentID" },
      { key: "Status" },
      { key: "Redenied" },
      { key: "AssignedTo" },
      { key: "WhatsNeeded" },
      { key: "DueDate", type: "date" },
      { key: "ActionTaken" },
      { key: "CompletedBy" },
      { key: "DateCompleted", type: "date" },
      { key: "LastNote" },
      { key: "CreatedOn", type: "date" },
      { key: "UpdatedOn", type: "date" }
    ];

    const sanitizedData = denialList.map(item => ({
      PracticeName: item.PracticeName,
      CustomerID: Number(item.CUSTOMERID),
      ClaimID: Number(item.CLAIMID),
      EncounterID: Number(item.EncounterID),
      PatientID: Number(item.PATIENTID),
      PatientName: item.PatientName,
      DOB: toExcelDateMidnightUTC(item.DOB),
      ServiceStartDate: toExcelDateMidnightUTC(item.ServiceStartDate),
      RenderingProviderID: Number(item.RENDERING_PROVIDER_ID),
      RenderingProviderName: item.RENDERING_PROVIDER_NAME,
      SchedulingProviderID: Number(item.SCHEDULING_PROVIDER_ID),
      SchedulingProviderName: item.SchedulingProviderName,
      ServiceLocationName: item.ServiceLocationName,
      InsPhone: formatPhoneNumber(item.InsPhone),
      PolicyNumber: item.PolicyNumber,
      BilledTo: item.Billed_to,
      InsPlanID: Number(item.InsPlanID),
      Code: item.Code,
      Mod1: item.Mod,
      DXC1: item.DXC1,
      TotalCharge: Number(item.Total_Charge),
      Balance: Number(item.Balance),
      AdjCode: item.Adj_Code,
      Remark: item.Remark,
      Advice: item.ADVICE,
      IssueType: item.issueType,
      DenialDate: toExcelDateMidnightUTC(item.Denial_Date),
      PaymentID: Number(item.PAYMENTID),
      Status: showDenialListByFilter == "workList" ? "Worklist" : showDenialListByFilter == "completed" ? "Completed" : "Pending Worked Validation",
      Redenied: item.Redenied == false || item.Redenied == null ? "No" : "Yes",
      AssignedTo: item.userName,
      WhatsNeeded: item.WhatsNeeded,
      DueDate: toExcelDateMidnightUTC(item.DueDate),
      ActionTaken: item.ActionTaken,
      CompletedBy: item.CompletedBy,
      DateCompleted: item.DateCompleted,
      LastNote: item.Notes[0] != undefined ? item.Notes[0].NOTES : "",
      CreatedOn: toExcelDateMidnightUTC(item.created_at),
      UpdatedOn: toExcelDateMidnightUTC(item.updated_at),
    }))

    // Convert to array of arrays (values only, no headers)
    const dataOnly = sanitizedData.map(item =>
      exportColumns.map(col => item[col.key])
    );

    // Create a new empty worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    // 1. Add the header row starting at A1
    XLSX.utils.sheet_add_aoa(worksheet, [exportColumns.map(col => col.key)], { origin: "A1" });

    // 2. Add the data starting from A2 (after the header)
    XLSX.utils.sheet_add_aoa(worksheet, dataOnly, { origin: "A2" });

    // const worksheet = XLSX.utils.aoa_to_sheet(dataOnly);
    // XLSX.utils.sheet_add_aoa(
    //   worksheet,
    //   [exportColumns.map(col => col.key)], // build header row from exportColumns
    //   { origin: "A1" }
    // );


    // Apply styles
    exportColumns.forEach((col, colIndex) => {
      const colLetter = XLSX.utils.encode_col(colIndex);
      for (let rowIndex = 1; rowIndex <= sanitizedData.length + 1; rowIndex++) {
        const cellAddress = `${colLetter}${rowIndex}`;
        const cell = worksheet[cellAddress];
        if (cell) {
          if (col.type === "integer") {
            cell.s = { numFmt: "0" };
          } else if (col.type === "decimal") {
            cell.s = { numFmt: "0.00" };
          } else if (col.type === "date") {
            cell.s = { numFmt: "mm/dd/yyyy" };
          }
        }
      }
    });

    const workbook = XLSX.utils.book_new();
    console.log(workbook)
    XLSX.utils.book_append_sheet(workbook, worksheet, "Denial Worklist");
    XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`, {
      Props: { Title: exportedExcelName }
    });
  };

  const styles = {
    content: {
      width: "100%",
      marginTop: "0rem",
    },
  };

  const rowCount = 1000;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowCount);
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalRows, setTotalRows] = useState("");
  const [lastUpdatedAt, setLastUpdatedAt] = useState(false);
  const fetchController = useRef({
    isFetching: false,
    abortController: null
  });
  const getDenialWorklist = useCallback(async (
    pageNum = 1,
    limit = rowsPerPage,
    forceRefresh = false
  ) => {
    // Prevent concurrent fetches
    if (fetchController.current.isFetching && !forceRefresh) {
      console.log('Fetch already in progress');
      return;
    }
    if (fetchController.current.abortController) {
      fetchController.current.abortController.abort();
    }
    const abortController = new AbortController();
    fetchController.current = {
      isFetching: true,
      abortController
    };
    try {
      setShowLoader(true)
      setShowCancelLoader(false);
      let chargesTimer = setTimeout(() => setShowCancelLoader(!showCancelLoader), 15000)
      const response = await API.get('getDenialData', {
        params: {
          page: pageNum,
          limit: limit
        },
        signal: abortController.signal
      });
      if (response.data?.success) {
        clearTimeout(chargesTimer)
        const { data, pagination } = response.data;
        setDenialList(data);
        setDenialListCopy(data);
        setDenialListAllRows(data);
        setShowLoader(false)
        setTotalRecord(pagination?.totalRecords || 0);
        setEncounterCount(response.data.uniqueRows || 0);
        setTotalRows(response.data?.totalRows)
        setLastUpdatedAt(response.data?.lastUpdatedAt)
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Fetch aborted');
        return;
      }
      NotificationManager.error('Failed to load data', 'Error');
    } finally {
      fetchController.current.isFetching = false;
      fetchController.current.abortController = null;
      setShowLoader(false)
      setShowCancelLoader(false);
    }
  }, [rowsPerPage]);

  // Initial Data Load
  useEffect(() => {
    let isMounted = true;
    let timeoutId;
    const safeInitialFetch = () => {
      if (isMounted) {
        timeoutId = setTimeout(() => {
          getDenialWorklist(1, rowsPerPage, true);
        }, 0);
      }
    };
    // Prevent multiple initial loads
    if (!fetchController.current.isFetching) {
      safeInitialFetch();
    }
    return () => {
      isMounted = false;
      if (timeoutId) clearTimeout(timeoutId);
      if (fetchController.current.abortController) {
        fetchController.current.abortController.abort();
      }
    };
  }, []);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
    getDenialWorklist(newPage + 1);
  }, [getDenialWorklist]);

  const handleChangeRowsPerPage = useCallback((event) => {
    const newLimit = parseInt(event.target.value, 10);
    setPage(0);
    setRowsPerPage(newLimit);
    getDenialWorklist(1, newLimit);
  }, [getDenialWorklist]);

  const handleChangePractice = useCallback((selectedPractice) => {
    setPracticeIdFromSession("" + JSON.parse(sessionStorage.getItem('practice'))?.id);
    if (selectedPractice === 'all') {
      setIsAllPracticeSelected(true);
    } else {
      setIsAllPracticeSelected(false);
    }
    setPage(0);
    getDenialWorklist();
    resetState('updateDenailDetails');
  }, [getDenialWorklist]);


  useEffect(() => {
    if (location.state) {
      handlePracticeChangeByNotReviewPage({
        target: {
          value: location.state.practiceId
        },
        practiceData: location.state.practiceData,
      }, () => { });
      setShowDenialListByFilter("workList")
    }
  }, [location.state, handlePracticeChangeByNotReviewPage]);

  useEffect(() => {
    if (showDenialListByFilter === "workList") {
      getDenialWorklist();
    }
  }, [showDenialListByFilter, getDenialWorklist]);

  return (
    <section>
      {/*<SideBar
        handleChangePractice={(selectedPractice) => {
          resetState('updateDenailDetails')
          showDenialListByFilter === "workList" && getDenialWorklist(selectedPractice.id);
          setPracticeIdFromSession("" + JSON.parse(sessionStorage.getItem('practice'))?.id)
          if (selectedPractice === 'all') {
            setIsAllPracticeSelected(true)
          } else setIsAllPracticeSelected(false)
        }}
        hasAllPracticeOption={roleData.roleId === 3 ? false : true}
      />*/}
      <SideBar
        handleChangePractice={(selectedPractice) => {
          // Handle practice change
          handleChangePractice(selectedPractice);
        }}
        hasAllPracticeOption={roleData.roleId === 3 ? false : true}
        handlePracticeChangeByNotReviewPage={(method) =>
          setHandlePracticeChangeByNotReviewPage(() => method)
        }
        isNavigateFromDashborad={location?.state?.practiceId}
      />
      {showDenialListByFilter === "workList" && (
        <>
          <div className="section-layout" >
            <div className="row font-face-futura text-start">
              <span className="font18">Denial Management</span>
            </div>
            <div className="botDivider"></div>

            <div className="ruleout-grid  mb-3">
              <div>
                <div className="font-face-futura text-start noteDiv">
                  <span className="px-1">Note</span>
                  <textarea
                    placeholder="Write what was done to fix the claim..."
                    className="p-2 denialNote w-100"
                    name="denialNote"
                    value={updateDenailDetails.Note}
                    onChange={handleCheckboxClick}
                  />
                </div>
              </div>
              <div className="d-flex flex-column justify-content-center gap-2">
                {user?.roleId != 9 && <div className="ruleout-grid-three">
                  <div>
                    <span className="denial-forminput">
                      <label className="text-nowrap">Assigned To</label>
                      <Autocomplete
                        className="justify-content-start autocomplete-select2"
                        ref={autoCAssignRef}
                        onKeyDown={(event) => {
                          if (event.key === "Tab") {
                            if (assigntoHint.current) {
                              setAssigntoValue(assigntoHint.current);
                              setUpdateDenialdetails((item) => {
                                return {
                                  ...item,
                                  AssignedTo: assigntoHint.current,
                                };
                              });
                              event.preventDefault();
                            }
                          }
                        }}
                        onClose={() => {
                          assigntoHint.current = "";
                        }}
                        onChange={(event, newValue) => {
                          setAssigntoValue(
                            newValue && newValue.id
                              ? newValue.first_name + " " + newValue.last_name
                              : ""
                          );
                          setUpdateDenialdetails((item) => {
                            return {
                              ...item,
                              AssignedTo:
                                newValue && newValue.id ? newValue.id : "",
                            };
                          });
                        }}
                        blurOnSelect
                        // disablePortal
                        inputValue={assigntoValue}
                        id="combo-box-hint-demo-"
                        options={assignTo}
                        getOptionLabel={(option) =>
                          option ? `${option.first_name} ${option.last_name}${option.roleid === 9 ? " (External User)" : ""}` : ""
                        }
                        renderInput={(params) => {
                          return (
                            <Box className="autocompleteselect2-container" >
                              <TextField
                                className="autocompleteinput-container"
                                {...params}
                                onChange={(event) => {
                                  const newValue = event.target.value;
                                  setAssigntoValue(newValue);
                                  setUpdateDenialdetails((item) => {
                                    return { ...item, AssignedTo: newValue };
                                  });
                                  const matchingOption = assignTo.find(
                                    (option) =>
                                      option.first_name.startsWith(
                                        newValue
                                      ) ||
                                      option.last_name.startsWith(newValue)
                                  );
                                  if (newValue && matchingOption) {
                                    assigntoHint.current =
                                      matchingOption.first_name +
                                      " " +
                                      matchingOption.last_name;
                                  } else {
                                    assigntoHint.current = "";
                                  }
                                }}
                                placeholder="Select"
                              />
                            </Box>
                          );
                        }}
                      />
                    </span>
                  </div>
                  <div>
                    <span className="denial-forminput">
                      <label className="text-nowrap">What's Needed</label>
                      <select
                        name="WhatsNeeded"
                        value={updateDenailDetails.WhatsNeeded}
                        onChange={(event) => handleCheckboxClick(event)}
                        className="denialSelect2"
                      >
                        <option value="" disabled selected>Select</option>
                        {whatsNeededDenial.map((item) => (
                          <option key={item.key} value={item.key}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                  <div>
                    <span className="denial-forminput">
                      <label className="text-nowrap">Action Taken</label>

                      <select
                        className="denialSelect2"
                        name="Action"
                        value={updateDenailDetails.ActionTaken}
                        onChange={(event) => handleCheckboxClick(event)}
                      >
                        <option value="" disabled selected>Select</option>
                        {actionTakenD.map((item) => (
                          <option key={item.key} value={item.key}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                </div>}
                <div className="ruleout-grid-four">
                  {/* <div>
                    <span className="denial-forminput">
                        <label className="text-nowrap">Redenied</label>

                        <select
                          name="redenied"
                          value={updateDenailDetails.Redenied}
                          onChange={(event) => handleCheckboxClick(event)}
                          className="denialSelect2"
                        >
                          <option value="">Select</option>
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </span>
                  </div> */}
                  {user.roleId != 9 && <div>
                    <span className="denial-forminput">
                      <label className="text-center">Adjustment Code</label>

                      <select
                        name="adjCode"
                        className="denialSelect2"
                        value={updateDenailDetails.Adj_Code}
                        onChange={(event) => handleCheckboxClick(event)}
                      >
                        <option value="" disabled selected>Select</option>
                        {adjustCodeDenial.map((adj) => (
                          <option key={adj.key} value={adj.value}>
                            {adj.value}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>}
                  {user.roleId != 9 && <div>
                    <span className="denial-forminput">
                      <label className="text-nowrap">Remark</label>
                      <Autocomplete
                        className=" justify-content-start autocomplete-select2"
                        ref={autoCRemarkCRef}
                        onKeyDown={(event) => {
                          if (event.key === 'Tab') {
                            if (remarkHint.current) {
                              setRemarkValue(remarkHint.current);
                              setUpdateDenialdetails(item => {
                                return { ...item, Remark: remarkHint.current }
                              });
                              event.preventDefault();
                            }
                          }
                        }}
                        onClose={() => {
                          remarkHint.current = '';
                        }}
                        onChange={(event, newValue) => {
                          setRemarkValue(newValue && newValue.RemarkCode ? newValue.RemarkCode : '');
                          setUpdateDenialdetails(item => {
                            return { ...item, Remark: newValue && newValue.RemarkCode ? newValue.RemarkCode : '' }
                          });
                        }}
                        blurOnSelect
                        disablePortal
                        inputValue={remarkValue}
                        id="combo-box-hint-demo"
                        options={remarkData}

                        getOptionLabel={(option) => option.RemarkCode}
                        renderInput={(params) => {
                          return (
                            <Box className="autocompleteselect2-container">
                              <TextField
                                className="autocompleteinput-container"
                                {...params}
                                onChange={(event) => {
                                  const newValue = event.target.value;
                                  setRemarkValue(newValue);
                                  setUpdateDenialdetails(item => {
                                    return { ...item, Remark: newValue }
                                  });
                                  const matchingOption = remarkData.find((option) =>
                                    (option.RemarkCode).startsWith(newValue)
                                  );

                                  if (newValue && matchingOption) {
                                    remarkHint.current = matchingOption.RemarkCode;
                                  } else {
                                    remarkHint.current = '';
                                  }
                                }}
                                placeholder="select"
                              />
                            </Box>
                          );
                        }}
                      />
                    </span>
                  </div>}
                  {user.roleId != 9 && <div>
                    <span className="denial-forminput">
                      <label className="text-nowrap">Due Date</label>
                      <DatePicker
                        className="denialSelect2"
                        format={"MM-dd-yyyy"}
                        placeholderText="MM/DD/YYYY"
                        name="DueDate"
                        selected={updateDenailDetails.DueDate}
                        onChange={(date) =>
                          setUpdateDenialdetails((item) => {
                            return { ...item, DueDate: date };
                          })
                        }
                      // customInput={
                      // <MaskedInput
                      //     // pipe={"10-10-2025"}
                      //     mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                      //     guide={true}
                      //     keepCharPositions={true} />}
                      />
                    </span>
                  </div>}
                  <div>
                    <div className="denial-buttons">
                      <Button
                        className="text-white resetBtn"
                        variant="contained"
                        onClick={handleNotePopup}
                      >
                        <span className="text-capitalize font-face-futura">
                          View
                        </span>
                      </Button>
                      <Button
                        className="text-white resetBtn"
                        onClick={() => resetState("resetButtonHandle")}
                        variant="contained"
                      >
                        <span className="text-capitalize font-face-futura">
                          Reset
                        </span>
                      </Button>
                      {user.roleId == 9 ? <Button
                        className="text-white saveButn"
                        variant="contained"
                        onClick={updateDenailRow}>
                        <span className="text-capitalize font-face-futura">
                          Save
                        </span>
                      </Button> :
                        <ButtonGroup>
                          <Button
                            className="text-white saveButn curvebtn"
                            variant="contained"
                            onClick={updateDenailRow}
                          >
                            <span className="text-capitalize font-face-futura">
                              Save
                            </span>
                          </Button>
                          <Button
                            className="savebtn-dropdown"
                            size="small"
                            aria-controls={open ? 'split-button-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(e) => {
                              setAnchorEl(e.target)
                              setOpen(!open)
                            }}>
                            <ArrowDropDownIcon style={{ visibility: 'visible' }} />
                          </Button>
                          <Menu
                            id="split-button-menu"
                            className="savebtn-modal"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}>
                            <MenuItem onClick={undoLastAction}>Undo Last Action</MenuItem></Menu>
                        </ButtonGroup>}
                      {user?.roleId == 9 && <Button
                        className="text-white assignBtn"
                        variant="contained"
                      // onClick={updateNoResponseRow}
                      >
                        <span className="text-capitalize font-face-futura">
                          Assign Back
                        </span>
                      </Button>}
                    </div>
                  </div>
                  {noteRequired.visible && (
                    <Dialog
                      fullWidth
                      open={noteRequired.visible}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <div align="center" className="avatar3">
                        <CancelIcon
                          className="dialogCancel"
                          fontSize="large"
                        />
                      </div>
                      <div
                        align="center"
                        className="dialog-box3 dialog-box-denail"
                      >
                        <DialogTitle id="alert-dialog-title">
                          <span className="font-face-futura dialogTitle dialogTitlefontSize">
                            {(noteRequired.tagName || "").toUpperCase()}{" "}
                            REQUIRED
                          </span>
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description ">
                            <span className="font-face-futura dialogText">
                              A {noteRequired.tagName} is required before
                              changing this claim's status
                            </span>
                          </DialogContentText>
                          <Button
                            fullWidth
                            className="mt-4 dialogBtn"
                            variant="contained"
                            onClick={handleNoteRequired}
                          >
                            <span className="font-face-futura">GO BACK</span>
                          </Button>
                        </DialogContent>
                      </div>
                    </Dialog>
                  )}
                  {showRemovePopup && (
                    <RoAlert
                      show={showRemovePopup}
                      handleClose={() => handleRemovePopup()}
                      handleSubmit={() => {
                        updateData();
                        handleRemovePopup();
                      }}
                      title={"Remove Row?"}
                      type="info"
                      hideFooterLine={true}
                      content={
                        <div className="alert-footer-text text-center">
                          You are currently removing this claim as a denial We
                          will not count this as a denial in reporting and it
                          will remove it from the worklist
                          <br />
                          <br />
                          Once this is completed you cannot reverse this
                          decision. Would you like to remove the row?
                        </div>
                      }
                    />
                  )}
                  <ClaimNoteHistory
                    openNote={openNotePopup}
                    closeNotePopup={handleNotePopup}
                    firstPage={viewHistoryPage}
                    totalPage={updateDenailDetails.id.length}
                    clickNext={handleClickNextForView}
                    clickPrevious={handleClickPreviousForView}
                    viewData={viewHistoryData}
                  />
                </div>
              </div>
            </div>
            <div style={styles.content}>
              <div
                className={`1pt-4 table-responsive linkedprayer-table custom-size tableresponsivecustom denial-style  ${isAllPracticeSelected ? 'allpractices' : 'denial-container'} w-100 ${props.showRule ? "opentoggle1" : ""
                  }`}
              >
                { }{" "}
                <table className="denial-table">
                  <thead>
                    <tr>
                      <th className="first-header">
                        <div
                          className="innerdata"
                          style={{ borderRadius: "9px 0 0 9px" }}
                        >
                          <RoCheckbox
                            name={"checkboxForAllRows"}
                            value={checkboxForAllRows}
                            checked={checkboxForAllRows}
                            onChange={(e) => {
                              handleCheckboxClick(e, denialList)
                            }}
                          />
                        </div>
                      </th>
                      {isAllPracticeSelected && <th className="text-center">
                        <span>{"Practice"}</span>
                      </th>}
                      {denialHeader.map((col, index) => (
                        <th className="text-center" key={index}>
                          <span>{col.name}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!denialList?.length && !showLoader ? <NoRecordFound /> : denialList?.length > 0 &&
                      denialList?.map((data, idx) => (
                        <tr
                          style={{ cursor: "pointer" }}
                          key={idx}
                          className={`table-row ${updateDenailDetails.id.includes(
                            data.id
                          ) ? " active-tablerow" : ""} `}
                        >
                          <td>
                            <div
                              className="innerdata"
                              style={{ borderRadius: "9px 0 0 9px" }}
                            >
                              <RoCheckbox
                                name={"userCheckbox"}
                                value={data.id}
                                onChange={(e) => handleCheckboxClick(e, data)}
                                checked={updateDenailDetails.id.includes(
                                  data.id
                                )}
                              />
                            </div>
                          </td>
                          {/* <td style={{ textAlign: 'center' }}>
                                        <div className='innerdata'>{data.flag}</div>
                                    </td> */}
                          {isAllPracticeSelected && <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span title={data.PracticeName}>{data.PracticeAcronym}</span>
                            </div>
                          </td>}
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.CLAIMID}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              {data.EncounterID}
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.PatientName}
                                className="deal-content"
                              >
                                {data.PatientName}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              {/*{new Date(
                                data.ServiceStartDate
                              ).toLocaleDateString("en-US")}*/}
                              {/* {moment(data.ServiceStartDate).format("MM/DD/YYYY")} */}
                              {dateConvertToUSTime(data.ServiceStartDate)}
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.SchedulingProviderName}
                                className="deal-content"
                              >
                                {data.SchedulingProviderName}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.ServiceLocationName}
                                className="deal-content"
                              >
                                {data.ServiceLocationName}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.Billed_to}
                                className="deal-content"
                              >
                                {data.Billed_to}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.Code}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.Mod}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.DXC1}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.Total_Charge}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{data.Balance}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">{(data.Redenied == false || data.Redenied == null) ? "No" : "Yes"}</div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                className="one-line-ellipsis"
                                title={
                                  adjustCodeDenial.find(
                                    (item) => item.value === data.Adj_Code
                                  )?.desc
                                }
                              >
                                {data.Adj_Code}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata cstm-tooltip-container">
                              <div className="custom-toltip">
                                {data.Remark}
                                <div className="tooltip-text">
                                  <p>{data.Adj_Code + " " + data.Remark + ": " +
                                    remarkData.find(
                                      (item) => item.RemarkCode === data.Remark
                                    )?.Description}</p>
                                  <p>{data.advice && data.advice?.map(item => (<>{item.advice_code + ": " + item.description}<br /></>))}</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.AssignedTo}
                                className="one-line-ellipsis"
                              >
                                {data.userName}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              <span
                                title={data.whatsNeeded}
                                className="one-line-ellipsis"
                              >
                                {data.WhatsNeeded}
                              </span>
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="innerdata">
                              {dateConvertToUSTime(data.Denial_Date)}
                            </div>
                          </td>
                          <td>
                            <div className="innerdata">
                              {data.DueDate !== null ? (
                                <span className={moment(new Date().toLocaleDateString("en-US")).isAfter(new Date(data.DueDate).toLocaleDateString("en-US"))
                                  ? "duedate" : ""}
                                >
                                  {dateConvertToUSTime(data.DueDate)}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="rule-footer">
                  <div className="foot-flex">
                    {/* <div className='foot-right3'> */}
                    <div>
                      <div className="d-flex align-items-center">
                        <span className="text-dark font-face-futura">
                          {showCheckedValues &&
                            <><span className='fontw'>Filtered Encounters:{' '}
                              <span className='fw-normal'>{filterEncounterCount ? filterEncounterCount : 0}</span>
                            </span><br /></>
                          }
                          <span className='fontw'>Total Encounters: <span className='fw-normal'>{encounterCount}</span></span>
                        </span>
                        <IconButton className="export-container">
                          <div className='export-btn'>
                            <input
                              type="image"
                              src={exportIcon}
                              alt="exportDenial"
                              className="mx-1"
                              style={{ cursor: 'pointer' }}
                              onClick={() => exportDenialWorklist()}
                            />
                            <span className='export'>Export</span>
                          </div>
                        </IconButton>
                      </div>
                    </div>
                    <div className="ms-auto" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
                      <div>
                        <TablePagination
                          component="p"
                          // count={totalRecord}
                          count={isfilter ? filterRows : totalRecord}
                          page={page}
                          rowsPerPageOptions={[rowCount, 2000, 4000]} // Configurable options
                          onPageChange={handleChangePage}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          className='pendingtable-pagination'
                        />
                      </div>
                      <div className="ms-auto" style={{ display: "flex" }}>
                        <div>
                          <span className="text-dark font-face-futura">
                            <p className="fontw mb-0 text-start">
                              Total Claims: {isfilter ? filterRows : totalRows}{" "}
                            </p>
                            <span className="dateFont">
                              Last Updated:
                              {DenialCronLastUpdated ? new Date(DenialCronLastUpdated).toLocaleDateString('en-US') : moment(lastUpdatedAt).format("MM/DD/YYYY")}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }
      {
        (showDenialListByFilter === "pendingWorkedValidation" ||
          showDenialListByFilter === "completed") && (
          <div className="section-layout">
            <DenialTable filterType={showDenialListByFilter} showLoader={showLoader} />
          </div>
        )
      }

      {
        showLoader &&
        <Dialog
          fullWidth
          open={showLoader}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <div align="center" className={showCancelLoader ? 'avatar2' : 'avatar'}>
            <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
            <Loader className="mt-2" type='Oval'
              height={180}
              width={195}
              color="#5CB02C"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel='oval-loading'
              secondaryColor="#5CB02C"
              strokeWidth={2}
              strokeWidthSecondary={2} />
          </div>
          <div align="center" className={showCancelLoader ? 'dialog-box2' : 'dialog-box'}>
            <DialogTitle id="alert-dialog-title">
              <span className='font-face-futura dialogTitle'>{"Updating Denials"}</span>
            </DialogTitle>
            {showCancelLoader ?
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span className='dialogText'>Hold tight while we fetch a new list of denials!</span>
                </DialogContentText><br />
                <DialogContentText id="alert-dialog-description">
                  <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                  <span className='dialogText'>Give us a little bit longer</span>
                </DialogContentText>
                <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                  <span className='font-face-futura'>Cancel</span>
                </Button>
              </DialogContent> :
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span className='font-face-futura dialogText'>Let's get you a new list of denials!</span>
                </DialogContentText>
              </DialogContent>}
          </div>
        </Dialog>
      }

      <Footer
        selectValue={searchKey}
        onSelectChange={handleSelectChange}
        apiLoading={apiLoading}
        columnData={selectedColumnData}
        filterValue={filterKey}
        searchFilterValues={searchFilterValues}
        checkboxValues={checkboxValues}
        handleCheckbox={handleCheckboxValues}
        showSearch={showSearch}
        showCheckedValues={showCheckedValues}
        handleGoBack={handleGoBack}
        handleGobackCheckbox={handleGoBackCheckbox}
        filteredValues={filterData}
        filterTable={filterTable}
        clearFilter={clearFilter}
        optionSelector={optionSelector}
        statusDropdownHandler={statusDropdownHandler}
        claimSelector={claimSelector}
        setClaimSelector={setClaimSelector}
        handleClaimsDropdown={handleClaimsDropdown}
        labelValue={labelValue}
        handleDateChange={handleDateChange}
        denailFromAndToDate={denailFromAndToDate}
        selectHandler={selectHandler}
      />
    </section >
  );
};

export default DenialWorksheet;